// extracted by mini-css-extract-plugin
export var closeButton = "_ju-1";
export var closeX = "_ju-3";
export var container = "_ju-0";
export var image = "_ju-2";